<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
          <Commondropdownlist ref="topfrom" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </div>
        <div class="Btngroups">
          <CommonBtngroup :qhide="false" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <Productlinefiletable ref="protable" :tableData="tableData" :total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Productlinefiletable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import Productlinefiletable from './components/productlinefiletable.vue'
import { InventoryClassList } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    Productlinefiletable,
    Dialog,
    CommonBtngroup
  },
  data() {
    return {
      dialogVisibles: false,
      showorhide: true,
      total: 1,
      pageindex: 1,
      pageSize: 20,
      tableData: [],
      invClass: '',
      invClassName: '',
      ParentClass: '',
      formdata: [
        {
          inputdata: '',
          title: '产品编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '70px'
        },
        {
          inputdata: '',
          title: '产品名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px'
        },
        {
          inputdata: '',
          title: '上级产品线编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '110px'
        },

      ]
    }
  },
  mounted() {
    this.inventoryClassList()
  },
  methods: {
    async inventoryClassList() {
      let {
        data,
        code
      } = await InventoryClassList({
        invClass: this.invClass,
        invClassName: this.invClassName,
        ParentClass: this.ParentClass,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      //console.log(code, data)
      if (code == 0) {
        this.total = data.Count
        if (data.data) {
          this.tableData = data.data
          //console.log(this.$refs.protable,'protable')
          this.$refs.protable.fromdataadd[3].options = []
          data.data.map((item, index) => {
            let obj = {
              key: item.InvClass,
              value: item.InvClassName
            }
            this.$refs.protable.fromdataadd[3].options.push(obj)
            this.$refs.protable.fromdataedit[3].options.push(obj)
          })
        }

      }
    },
    reset() {
      this.$refs.topfrom.map((item, index) => {
        item.modelvalue = ''
      })
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.dialogVisibles = false
    },
    hide() {
      this.showorhide = false
    },
    select() {
      this.pageindex = 1
      this.invClass = this.$refs.topfrom[0].modelvalue
      this.invClassName = this.$refs.topfrom[1].modelvalue
      this.ParentClass = this.$refs.topfrom[2].modelvalue
      this.inventoryClassList()
    },
    showclick() {
      this.showorhide = true
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.inventoryClassList()
    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.inventoryClassList()

    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 10px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all 0.3s;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
}
.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 10px;
  width: 350px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 45px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 30px;
}
</style>